var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard45(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_45);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        stroke: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_45",
    "data-name": "Artboard \\u2013 45",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    className: "cls-2",
    d: "M14.178,15.68,8.07,9.559,1.962,15.68A1.144,1.144,0,0,1,.341,14.064L6.4,8,.337,1.95A1.144,1.144,0,0,1,1.958.335L8.07,6.443,14.183.335A1.144,1.144,0,0,1,15.8,1.95L9.744,8l6.054,6.06a1.144,1.144,0,0,1-1.621,1.615Z",
    transform: "translate(4.43 4.993)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard45);
export default __webpack_public_path__ + "static/media/Artboard – 45.9f5792bda5dec5a8f0217a072b186606.svg";
export { ForwardRef as ReactComponent };